export const ApiCalls = {
  activation: {
    activate: 'v1/registration',
  },
  accountSelection: {
    subscriptions: '/ssc/accounts/v2/customer/accounts/accounts-subscriptions',
    accountList: '/ssc/accounts/v2/customer/accounts/list',
    accountDetails: '/ssc/accounts/v2/customer/accounts/{account-alias}/account-details'
  },
};
